import React, { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useNavigation,
  useParams,
} from "react-router-dom";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { getAuth } from "firebase/auth";
import Drag from "../Components/draganddrop";
import cross from "../Assets/cross.svg";
import DummyImage from "../Assets/product_img.svg";
import upload from "../Assets/drag.svg";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import {
  Box,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  Paper as MuiPaper,
  Typography,
  TableRow,
  TableCell,
  Tooltip,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextareaAutosize,
} from "@material-ui/core";

import { Edit as EditIcon } from "@material-ui/icons";

import { spacing } from "@material-ui/system";
import { useHistory } from "react-router-dom";
import CheckboxLabels from "../Components/Checkbox";
import InputField from "../Components/inputfield";
import ButtonComponent from "../Components/buttton";
import ButtonIconComponent from "../Components/ButtonIcons";
import { AddSingleDoc, GetAllData } from "../NetworkCalls/Admin/ServerReq";
import DateRangeField from "../Components/DateRangeField";
import dayjs from "dayjs";
import UploadImage from "../Components/uploadimage";

const Divider = styled(MuiDivider)(spacing);
const Paper = styled(MuiPaper)(spacing);

function handleClick(event) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

function BasicBreadcrumbs() {
  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          to={"/dashboard/resturants"}
          underline="hover"
          color="#000"
          style={{ color: "#410660" }}
        >
          {" "}
          Resturants
        </Link>
        <Typography
          color="text.primary"
          style={{ fontWeight: "500", color: "#410660" }}
        >
          Edit Resturant
        </Typography>
      </Breadcrumbs>
    </div>
  );
}

const NewPlaces = () => {
  const history = useNavigate();

  const boxes = [
    { Label: "Admins", Check: true },
    { Label: "NFTs", Check: true },
    { Label: "Users", Check: true },
    { Label: "Categories", Check: true },
    { Label: "Sub Categories", Check: true },
    { Label: "Products", Check: true },
    { Label: "Orders", Check: true },
    { Label: "Refund Requests", Check: true },
    { Label: "Purchase History", Check: true },
    { Label: "Coupons", Check: true },
    { Label: "Coupons", Check: true },
    { Label: "Sub Categories", Check: true },
    { Label: "Products", Check: true },
    { Label: "Orders", Check: true },
    { Label: "Refund Requests", Check: true },
    { Label: "Purchase History", Check: true },
    { Label: "Coupons", Check: true },
    { Label: "Coupons", Check: true },
    { Label: "Sub Categories", Check: true },
    { Label: "Products", Check: true },
    { Label: "Orders", Check: true },
    { Label: "Refund Requests", Check: true },
    { Label: "Purchase History", Check: true },
    { Label: "Coupons", Check: true },
    { Label: "Coupons", Check: true },
    { Label: "Sub Categories", Check: true },
    { Label: "Products", Check: true },
    { Label: "Orders", Check: true },
    { Label: "Refund Requests", Check: true },
    { Label: "Purchase History", Check: true },
    { Label: "Coupons", Check: true },
    { Label: "Coupons", Check: true },
  ];

  const [Checkboxes, setCheckboxes] = useState(boxes);
  const [Error, setError] = useState("");
  const [data, setData] = useState({});

  const [loader, setLoader] = useState(false);
  const [mainLoader, setMainLoader] = useState(true);
  const [imgweb, setImgweb] = useState("");

  const [tempimg, setTempimg] = useState("");

  const { state } = useLocation();
  const [open, setOpen] = useState(false);
  const [Refresh, setRefresh] = React.useState(false);

  const [topMenusData, setTopMenusData] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [checkedAmenities, setCheckedAmenities] = useState([]);
  const [amenitiesLoading, setAmenitiesLoading] = useState(false);

  const [selectedDateRange, setSelectedDateRange] = React.useState([
    dayjs("2023-04-17"),
    dayjs("2023-04-21"),
  ]);

  const handleDateRangeChange = (newDateRange) => {
    setSelectedDateRange(newDateRange);
  };

  const handleOnchange = (e) => {
    const { name, value } = e.target;
    setData((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
  };

  // =======

  const handleClose = () => {
    setOpen(!open);
    history.push({ pathname: "/dashboard/nfts" });
    // setUpdate(!dataupdate)
  };

  async function handleClick(event) {
    event.preventDefault();
    setOpen(true);
  }

  // console.log(blogdata?.blogimg)
  const { setDragOver, onDragOver, onDragLeave, setFileDropError } = Drag();
  

  const onDrop = (e) => {
    
    e.preventDefault();

    setDragOver(false);

    const selectedFile = e?.dataTransfer?.files[0];

    if (selectedFile.type.split("/")[0] !== "image") {
      return setFileDropError("Please provide an image file to upload!");
    }

    setTempimg(selectedFile);

  };

  const addCheckboxes = (e) => {
    const { name, checked } = e.target;

    if (checked) {
      setCheckedAmenities((prevChecked) => [...prevChecked, name]);
    } else {
      setCheckedAmenities((prevChecked) =>
        prevChecked.filter((id) => id !== name)
      );
    }
  };

  // Get All Top Menus

  useEffect(() => {
    const getDataTopMenus = async () => {
      try {
        const response = await GetAllData("TopMenus");

        let arr = [];
        response.forEach((doc) => {
          arr.push(doc.data());
        });
        setTopMenusData(arr);
      } catch (error) {
        throw error;
      }
    };

    getDataTopMenus();
  }, [Refresh]);

  // Get All Ameneities
  useEffect(() => {
    const getAmenities = async () => {
      try {
        setAmenitiesLoading(true);
        const response = await GetAllData("Amenities");

        let arr = [];
        response.forEach((doc) => {
          arr.push(doc.data());
        });

        arr.sort((a, b) => a.name.localeCompare(b.name));

        setAmenities(arr);

        setAmenitiesLoading(false);
      } catch (err) {
        console.log(err);
        setAmenitiesLoading(false);
      } finally {
        setAmenitiesLoading(false);
      }
    };

    getAmenities();
  }, [Refresh]);

  // Add new place
  const handleAddNewPlace = async (e) => {
    e.preventDefault();

    try {
      const formattedDateRange = selectedDateRange.map((date) =>
        dayjs(date).format("DD/MM/YYYY")
      );

      setLoader(true);

      UploadImage({ img: tempimg }).then(async (res) => {
        setImgweb(res);

       const response = await AddSingleDoc("Restaurants", {
          ...data,
          startDate: formattedDateRange[0],
          endDate: formattedDateRange[1],
          ameneities: checkedAmenities,
          imageLink: res,
        });
        console.log("response================================")
        console.log(response)

         setLoader(false);
      });

     
    } catch (e) {
      setLoader(true);
    } finally {
      setLoader(false);
    }
  };

  return (
    <React.Fragment>
      <Grid
        style={{ marginBottom: "10px" }}
        justify="space-between"
        container
        spacing={24}
      >
        <Grid item>
          <Typography
            variant="h4"
            gutterBottom
            display="inline"
            style={{ color: "#410660" }}
          >
            New Places
          </Typography>
        </Grid>
      </Grid>

      <Divider
        my={6}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          backgroundColor: "#fafafa",
        }}
      />

      <Paper
        style={{
          boxShadow: "none !important",
          border: "1px solid rgba(76, 78, 100, 0.25)",
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <Grid item xs={12} xl={6} lg={12} md={6}>
          <Grid
            style={{ marginBottom: "10px", marginTop: "35px" }}
            justify="space-around"
            container
            spacing={2}
          >
            <Grid item xs={12} xl={12} lg={12} md={12}>
              <p style={{ fontSize: "20px", marginBottom: "20px" }}>
                Asset Image
              </p>

              {/* ======= */}

              {imgweb == "" && tempimg == "" ? (
                <div className="addImage"
                    for="upload-photo"
                    onDragOver={onDragOver}
                    onDragLeave={onDragLeave}
                    onDrop={onDrop}>
                  <div className="imagebody"  >
                    <img src={upload} style={{ marginBottom: "20px" }} />
                    <p>
                      Drag and drop an image, or{" "}
                      <label
                        for="upload-photo"
                        className="upload-label"
                      >
                        Browse{" "}
                      </label>
                      <input
                        type="file"
                        name="WebImage"
                        onChange={(e) => {
                          setTempimg(e.target.files[0]);
                        }}
                        id="upload-photo"
                        style={{ display: "none" }}
                        // required={true}
                      />
                      <br /> 1600x1200 or higher recommended. Max 10MB.
                    </p>
                  </div>
                </div>
              ) : (
                <div className="addImage">
                  <>
                    <label
                      for="upload-photo"
                      className="upload-label"
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "relative",
                      }}
                      onDragOver={onDragOver}
                      onDragLeave={onDragLeave}
                      onDrop={onDrop}
                    >
                      <input
                        type="file"
                        name="WebImage"
                        onChange={(e) => {
                          // UploadImage({ img: e.target.files[0] }).then(
                          //   (res) => {
                          //     setImgweb(res);

                          //   }
                          // );
                          setTempimg(e.target.files[0]);
                        }}
                        id="upload-photo"
                        style={{ display: "none" }}
                      />

                      <img
                        src={cross}
                        style={{
                          width: "35px",
                          top: "-25px",
                          position: "absolute",
                          right: "-25px",
                        }}
                        onClick={() => {
                          tempimg == "" ? setImgweb("") : setTempimg("");
                        }}
                      />
                      {tempimg == "" ? (
                        <img
                          src={DummyImage}
                          style={{ width: "100%", height: "100%" }}
                        />
                      ) : (
                        <img
                          src={URL.createObjectURL(tempimg)}
                          style={{ width: "100%", height: "100%" }}
                        />
                      )}
                    </label>
                  </>
                </div>
              )}

              {/* ======== */}
            </Grid>
          </Grid>
        </Grid>

        <div className="dashboard_container">
          <form onSubmit={handleAddNewPlace}>
            <Grid
              style={{ marginBottom: "10px", marginTop: "35px" }}
              container
              spacing={2}
            >
              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="businessName"
                  label="Name"
                  variant="outlined"
                  required
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="address"
                  label="Address"
                  variant="outlined"
                  required
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="city"
                  label="City"
                  variant="outlined"
                  required
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="state"
                  label="State"
                  variant="outlined"
                  required
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="number"
                  name="zip"
                  label="Postal Code"
                  variant="outlined"
                  required
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="number"
                  name="phone"
                  label="Number"
                  variant="outlined"
                  required
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="email"
                  name="email"
                  label="Email"
                  variant="outlined"
                  required
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>


              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="url"
                  label="URL"
                  variant="outlined"
                  required
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="demo-simple-select-label">
                    Food category
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Enter menu category"
                    name="category"
                    required
                    onChange={handleOnchange}
                  >
                    {topMenusData &&
                      topMenusData.map((item, index) => (
                        <MenuItem key={index} value={item?.id}>
                          {item?.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="demo-simple-select-label">
                    Business Category
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Enter menu category"
                    name="businessCategory"
                    required
                    onChange={handleOnchange}
                  >
                    {["Breweries", "Catering", "Restaurants", "Wineries"].map(
                      (item, index) => (
                        <MenuItem key={index} value={item}>
                          {item}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="demo-simple-select-label">
                    Subscriptions Package
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Enter menu category"
                    name="package"
                    required
                    onChange={handleOnchange}
                  >
                    {["Basic", "Normal", "Business", "Enterprise"].map(
                      (item, index) => (
                        <MenuItem key={index} value={item}>
                          {item}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="demo-simple-select-label">
                    Listings Status
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Enter menu category"
                    name="status"
                    required
                    onChange={handleOnchange}
                  >
                    {["General", "Featured"].map((item, index) => (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="number"
                  name="points"
                  label="Points"
                  variant="outlined"
                  required
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="number"
                  name="redeemedReward"
                  label="Redeemed Reward"
                  variant="outlined"
                  required
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={12} lg={12} md={12}>
                <DateRangeField onDateRangeChange={handleDateRangeChange} />
              </Grid>
            </Grid>

            <Grid style={{ margin: "2rem 0" }}>
              <Typography
                variant="h4"
                gutterBottom
                display="inline"
                style={{ color: "#410660" }}
              >
                Dining:
              </Typography>

              <RadioGroup
                style={{ width: "fit-content", marginTop: "10px" }}
                name="dining"
                required
                onChange={handleOnchange}
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio style={{ color: "#448aff" }} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio style={{ color: "#448aff" }} />}
                  label="No"
                />
              </RadioGroup>
            </Grid>

            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              style={{ color: "#410660" }}
            >
              Amenities:
            </Typography>

            <Grid
              container
              style={{
                marginTop: "15px",
                marginBottom: "40px",
              }}
            >
              {amenities &&
                amenities.length > 0 &&
                amenities.map((item, index) => (
                  <Grid key={index} item xs={12} md={6} lg={3} xl={4}>
                    <CheckboxLabels
                      name={item.id}
                      Label={item.name}
                      check={
                        checkedAmenities && checkedAmenities.includes(item.id)
                      }
                      onClick={addCheckboxes}
                      required
                    />
                  </Grid>
                ))}
            </Grid>

            <Grid item xs={12} xl={12} lg={12} md={12}>
              <Typography
                variant="h5"
                gutterBottom
                display="inline"
                style={{ color: "#410660" }}
              >
                Notes
              </Typography>
              <TextareaAutosize
                minRows={8}
                name="notes"
                required
                onChange={handleOnchange}
                placeholder="Write here"
                style={{
                  border: "1px solid #c4c4c4",
                  width: "100%",
                  fontSize: "16px",
                  padding: "15px",
                  outline: "none",
                }}
              />
            </Grid>

            <div
              style={{
                width: "50%",
                margin: "2rem auto",
              }}
            >
              <ButtonIconComponent
                loader={loader}
                name="Submit"
                imageBool={false}
                type="submit"
              />
            </div>

            <Box mt={2}>
              <Typography style={{ color: "#E12F2F" }}>{Error}</Typography>
            </Box>
            {/* <button>hdsdsu</button> */}
          </form>
        </div>
      </Paper>
    </React.Fragment>
  );
};

export default NewPlaces;
